// src/components/PostHogProvider.tsx
"use client";

import { Suspense, useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import {
  captureInitialUtm,
  initPostHog,
  syncEventScope,
  trackPageview,
} from "@/lib/analytics";

// Init a nivel de módulo: el provider se carga antes de cualquier child, así
// que cuando `<PostHogPageView>` corre su useEffect (después de los effects de
// los hijos) PostHog ya está inicializado. Hacerlo en useEffect del provider
// pierde el primer pageview porque los effects de los hijos corren primero.
if (typeof window !== "undefined") {
  initPostHog();
}

function PostHogPageView() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!pathname) return;
    const sp = new URLSearchParams(searchParams?.toString() ?? "");
    // Primero el alcance (FEATURE-205 RF-06): `register` escribe sincrónicamente, así que el
    // `$pageview` de más abajo ya sale con `association`/`surface`, igual que los eventos
    // posteriores (los web vitals llegan unos segundos después). Al revés, el evento más
    // importante —la llegada del hincha— quedaría sin etiquetar.
    syncEventScope();
    captureInitialUtm(sp);
    trackPageview(window.location.href);
  }, [pathname, searchParams]);

  return null;
}

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Suspense fallback={null}>
        <PostHogPageView />
      </Suspense>
      {children}
    </>
  );
}
